import React from 'react'
import styled from "styled-components"

export function InventoryIcon () {
    return(
        <InventoryIconWrap className="pc_icons_inventory">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
        </InventoryIconWrap>
    )
}
export function PrintIcon ({size}) {
    return (
        <PrintIconWrap size={size} className="pc_icons_printer_icon">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
            <span className="path4"></span>
            <span className="path5"></span>
            <span className="path6"></span>
            <span className="path7"></span>
            <span className="path8"></span>
        </PrintIconWrap>
    )
}
export function OsIcon ({size}) {
    return (
        <OsIconWrap size={size} className="pc_icons_os_down"/>
    )
}

const InventoryIconWrap = styled.i`
    font-size: 24px;
    span { font-size: 24px !important; }
`
const PrintIconWrap = styled.i`
    font-size: ${props => props.size ? `${props.size}px` : '24px'};
    span { font-size: ${props => props.size ? `${props.size}px` : '24px'} !important; }
`
const OsIconWrap = styled.i`
    font-size: ${props => props.size ? `${props.size}px` : '24px'};
`



// WEBPACK FOOTER //
// ./src/estimate_list/common/icons.js